import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import SubscribeForm from '../SubscribeForm';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Explore': [
      { path: '/blog', label: 'Blog' },
      { path: '/dive-sites', label: 'Dive Sites' },
      { path: '/about', label: 'About' },
      { path: '/contact', label: 'Contact' },
    ],
  };

  const socialLinks = [
    { icon: FaFacebook, url: 'https://facebook.com', label: 'Facebook' },
    { icon: FaTwitter, url: 'https://twitter.com', label: 'Twitter' },
    { icon: FaInstagram, url: 'https://instagram.com', label: 'Instagram' },
    { icon: FaYoutube, url: 'https://youtube.com', label: 'YouTube' },
  ];

  return (
    <footer className="footer">
      <div className="footer-subscribe-band">
        <div className="container">
          <SubscribeForm variant="footer" />
        </div>
      </div>
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3 className="footer-title">Nothing But Scuba</h3>
              <p className="footer-description">
                A blog about my scuba diving adventures around the world.
              </p>
              <div className="social-links">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={social.label}
                  >
                    <social.icon />
                  </a>
                ))}
              </div>
            </div>

            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category} className="footer-section">
                <h4 className="footer-subtitle">{category}</h4>
                <ul className="footer-links">
                  {links.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path} className="footer-link">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="footer-section">
              <h4 className="footer-subtitle">Where am I?</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <FaMapMarkerAlt className="contact-icon" />
                  <span>London, UK</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Nothing But Scuba. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 